import React, { Component, Fragment } from 'react'
// import {connect} from "react-redux";
import groupBy from 'lodash/groupBy'
import each from 'lodash/each'
import map from 'lodash/map'
import setQuery from 'set-query-string'
import { parseQuery, generateQueryForTrip } from '../../utils'
import API from './../../api'

import { createUrl } from './../../localized-urls'
import { FormattedMessage } from 'react-intl'
import PriceConverter from './../helpers/PriceConverter'
import DateFormat from './../helpers/DateFormat'
import { showItineraryPopup, setItineraryData } from '../../actions/main-actions'
import Pagination from 'react-js-pagination'
import OperatorSwitch from './OperatorSwitch'
import PlaceholderTrips from './PlaceholderTrips'

const PAGE_SIZE = 50

export default class TripsComponent extends Component {
  constructor(props) {
    super(props)

    const query = parseQuery()
    this.state = {
      loading: true,
      page: query && query.page ? +query.page : 1,
      trips: [],
      pageCount: 0,
    }

    this.tripContainerRef = React.createRef()
  }

  componentDidUpdate(prevProps) {
    if(JSON.stringify(prevProps.selectedParams) !== JSON.stringify(this.props.selectedParams)) {
      this.setState({
        page: 1,
        loading: true,
      }, this.getTrips)
    }
  }

  componentDidMount() {
    this.getTrips()
  }

  showItinerary = (trip) => {
    this.props.dispatch(setItineraryData({
      isCharter: trip.isCharter,
      itinerarySlug: trip.itinerarySlug,
      tripId: trip.id,
      dateFrom: trip.startDate,
      duration: trip.duration,
      currency: this.props.currency,
      shopSlug: trip.slug || trip.shopSlug,
      countrySlug: trip.referenceLocationCountrySlug || trip.countrySlug,
      insurance: trip.includeFreeDiveInsurance && this.props.insurance,
    }))
    this.props.dispatch(showItineraryPopup(true))
  }

  getTrips = () => {
    const { model, pk } = this.props

    return API(`search/${model.toLowerCase()}/${pk}/trips/`).get({
      infinity_fx35: true,
      page: this.state.page,
      page_size: PAGE_SIZE,
      ...this.props.selectedParams,
    }).then((trips) => {
      let groupedByDates = groupBy(trips.results, 'startDate')
      let obj = {}

      each(groupedByDates, function(val, key) {
        var i = 0

        each(val, function(v) {
          if(!v.availableSpots) {
            i++
          } else {
            if(!obj[key]) {
              obj[key] = []
            }

            obj[key].push(v)
          }
        })

        if(obj[key] && obj[key][0]) {
          obj[key][0].totalSpotsSells = i
        }
      })

      this.props.setNumberOfItems(trips.count, 'numberOfTrips')

      this.setState({
        trips: map(obj),
        loading: false,
        numberOfTrips: trips.count,
      })

      // dispatch(setNumberOfItems(trips.count))
    })
  }

  onPageChange = (page) => {
    window.scrollTo(0, this.tripContainerRef.current.offsetTop)
    setQuery({ page })

    this.setState({
      page,
      loading: true,
    }, this.getTrips)
  }

  render() {
    if(this.state.loading) {
      return (
        <Fragment>
          {
            [...new Array(10)].map((_, i) => {
              return (<PlaceholderTrips key={i} />)
            })
          }
        </Fragment>
      )
    }
    return (
      <div ref={this.tripContainerRef}>
        {
          this.state.trips.map((dateTrip, index) => {
            return (
              <div className='date-list' key={index}>
                <div className='header'>
                  <div className='date'><DateFormat date={dateTrip[0].startDate} /></div>
                  { dateTrip[0].totalSpotsSells
                    ? (<div>
                      <FormattedMessage
                        id='fully_booked_spots'
                        defaultMessage='{ spots } fully booked { spots, plural, one {trip} other {trips}} hidden'
                        values={
                          {
                            spots: dateTrip[0].totalSpotsSells,
                          }
                        }
                      />
                    </div>) : ''
                  }
                </div>
                {
                  dateTrip.map((trip) => {
                    return (
                      <div key={trip.id}
                        onClick={() => window.open(createUrl('la_page', { location: trip.referenceLocationCountrySlug || trip.countrySlug, slug: trip.slug || trip.shopSlug }, generateQueryForTrip(trip, this.props.isWidget)), '_blank')}
                        className={`row${trip.grossPrice < trip.compareAtPrice ? ' is-deal' : ''}`}>
                        <div className='date'>
                          <DateFormat date={trip.startDate} format='D MMM' />&nbsp;
                          <span className='hidden-xs'>></span>
                        </div>
                        <div className='date'><DateFormat date={trip._endDate} format='D MMM' /></div>
                        <div className='number-of-nights'>{ trip.duration } <FormattedMessage id='nights' defaultMessage='nights' /></div>
                        <div className='title'>
                          <p className='bold'>{ trip.shopTitle }</p>
                          <a className='pointer' onClick={e => { e.stopPropagation(); this.showItinerary(trip) }}>
                            <i className='font-icons route-icon'>&nbsp;</i>
                            { trip.itineraryTitle }
                          </a>
                        </div>
                        <div className='availability'>
                          {
                            trip.availableSpots && trip.availableSpots < 5
                              ? <FormattedMessage
                                id='spots_left_plural'
                                values={{
                                  spots: trip.availableSpots,
                                }}
                                defaultMessage='{spots, plural, one {# spot} other {# spots}} left'
                              /> : ''
                          }
                        </div>
                        <div className='pricing'>
                          {
                            trip.isCharter
                              ? (<span className='charter'><FormattedMessage id='charter_only' defaultMessage='Charter only' /></span>)
                              : (<Fragment>
                                <span className='from'><FormattedMessage id='from' defaultMessage='From' />&nbsp;</span>
                                <span className='price'><PriceConverter currency={trip.currency} amount={trip.grossPrice} /></span>
                                <span className='price-type hidden-xs'>/ <FormattedMessage id='trip' defaultMessage='trip' /></span>
                                <span className='price-type visible-xs'><FormattedMessage id='per_trip' defaultMessage='PER TRIP' /></span>
                              </Fragment>)
                          }
                        </div>
                      </div>)
                  })
                }
              </div>)
          })
        }
        {
          !this.state.loading ? (<OperatorSwitch {...this.props.resortDetails} />) : ''
        }
        <div className='pagination-wrap'>
          <Pagination
            activePage={this.state.page}
            innerClass='custom-pagination'
            itemsCountPerPage={PAGE_SIZE}
            itemClassPrev='prev'
            itemClassNext='next'
            prevPageText=''
            nextPageText=''
            itemClassFirst='hidden'
            itemClassLast='hidden'
            totalItemsCount={this.state.numberOfTrips}
            pageRangeDisplayed={5}
            onChange={this.onPageChange}
          />
        </div>
      </div>
    )
  }
}

// export default connect(
//   state => ({
//       pageLoader: state.pageLoader,
//       numberOfTrips: state.numberOfTrips
//   })
// )(TripsComponent)
